export class FactoresEBR {
    public tabla: string;
    public factorId:number;
    public lstFactores:DetalleFactorEBR[];
    public EsEBR:number;

    constructor() {
        this.factorId = 0;
        this.tabla = '';
    }
}

export class DetalleFactorEBR {
    public id:number;
    public riesgoId:number;
    constructor() {
        this.id = 0;
        this.riesgoId = 0;
    }
}
